module.exports = __webpack_public_path__ + "img/sh3help.dd6f72a8.png";